import React from 'react';

import Axios from 'axios';

import styled from 'styled-components';

import { forceReloadContact } from '@hooks/API/Contact/UseContact';
import { forceReloadContactBankAccounts } from '@hooks/API/Contact/UseContactBankAccounts';
import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';

import FlexContainer from '@components/Gui/FlexContainer';
import { NwCard } from '@components/Gui/NwCard/NwCard';
import NwDivider from '@components/Gui/NwDivider';
import NwDropDownMenu from '@components/Gui/NwDropDownMenu';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const DetailValue = styled.div`
    font-size: 0.95rem;
    font-weight: bold;
    margin-right: ${(props) => !props.isMobile && '4px'};
`;

const DetailLabel = styled.div`
    font-size: 0.95rem;
`;

const BankAccountItem = ({ item, contactId, onEditDoc }) => {
    const breakpoints = useNwBreakPoints();

    const deleteBankACcount = async () => {
        try {
            await Axios.delete(`/ContactBankAccounts/${item.ID}`);
            forceReloadContactBankAccounts(contactId);
            forceReloadContact(contactId);
        } catch (error) {
            console.error('delete bank account error => ', error);
        }
    };

    const renderActions = () => {
        return (
            <NwDropDownMenu
                size="small"
                actions={[
                    { name: '', key: 'edit', pinned: true, icon: byPrefixAndName.fasl['pen'], action: onEditDoc },
                    {
                        name: 'delete',
                        type: 'delete',
                        key: 'delete',
                        icon: byPrefixAndName.fasl['trash-alt'],
                        confirmationPlacement: 'left',
                        action: () => {
                            deleteBankACcount(item.ID);
                        },
                    },
                ]}
            />
        );
    };

    return (
        <NwCard title={item.BankName} extra={renderActions()}>
            <FlexContainer column={breakpoints === 1} alignItems="flex-start">
                <DetailLabel isMobile={breakpoints === 1}>IBAN:</DetailLabel>
                <DetailValue>{item.IBAN}</DetailValue>
            </FlexContainer>
            <FlexContainer column={breakpoints === 1} alignItems="flex-start">
                <DetailLabel isMobile={breakpoints === 1}>BIC / SWIFT:</DetailLabel>
                <DetailValue>{item.BIC}</DetailValue>
            </FlexContainer>
            <NwDivider>Description</NwDivider>
            <DetailLabel>{item.Description}</DetailLabel>
            <NwDivider icon={byPrefixAndName.fasl['lock-alt']}>Internal Notes</NwDivider>
            <DetailLabel>{item.InternalNote}</DetailLabel>
        </NwCard>
    );
};

export default BankAccountItem;
